/* Adjust the Journal hero to fit the first visible viewport, including the
   measured subject navigation. Purely a layout measurement, no search/actions. */
(function(){
 'use strict';
 function setup(root){
  if(root.dataset.ajHeroFitReady==='1')return;
  const hero=root.querySelector('.aj__masthead--collage');
  const nav=root.querySelector('.aj__quicknav--subjects');
  if(!hero||!nav)return;
  root.dataset.ajHeroFitReady='1';
  const lifecycle=new AbortController(),signal=lifecycle.signal;
  let observer=null,disposed=false;
  let initialOffset=null,frame=0;
  function update(){
   frame=0;if(disposed)return;
   const navHeight=Math.ceil(nav.getBoundingClientRect().height);
   if(initialOffset===null||window.scrollY<=2){
    initialOffset=Math.max(0,Math.min(window.innerHeight*.42,Math.round(hero.getBoundingClientRect().top)));
   }
   if(navHeight>0)hero.style.setProperty('--aj-nav-measured',navHeight+'px');
   hero.style.setProperty('--aj-start-offset',Math.round(initialOffset)+'px');
  }
  function request(){if(frame)cancelAnimationFrame(frame);frame=requestAnimationFrame(update)}
  request();
  window.addEventListener('resize',request,{passive:true,signal});
  window.addEventListener('orientationchange',request,{passive:true,signal});
  if('ResizeObserver' in window){observer=new ResizeObserver(request);observer.observe(nav);}
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))(()=>{disposed=true;if(frame)cancelAnimationFrame(frame);observer?.disconnect();lifecycle.abort();delete root.dataset.ajHeroFitReady;})();},{signal});
 }
 function init(){document.querySelectorAll('.aj').forEach(setup)}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();